import { button } from "framer-motion/client"
import styles from "./Team.module.css"
import { useNavigate } from "react-router-dom"

function Team() {
    const navigate = useNavigate()

    function handleContact() {
        navigate("/contact");
    }

    return(
        <section className={styles.team}>
        <div className={styles.card}>
            <h2>Let's go, Meet our <span>team.</span></h2>
            <button onClick={handleContact}> Let's Talk </button>
        </div>
        </section>
    )
}

export default Team

